module.exports = __webpack_public_path__ + "img/5f_r_torikoma@2x.24016b0c.png";